import React from 'react';
import { connect } from 'react-redux';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import BusinessMandateGroup from '../businessMandateSection/BusinessMandateGroup';
import { BUSINESS_MANDATE, BUSINESS_MANDATE_ACCOUTS } from '../radioOptions';
import { getLabelByKey } from '../../utils/businessUtils';
import { content } from '../../infrastructure/content/selectors';

class BusinessMandateAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEdit: false };
    this.saveBusinessMandateForm = this.saveBusinessMandateForm.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
  }

  handleEditClick() {
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(false);
  }

  renderContentType(values, pristine) {
    const { bankId, externalContent } = this.props;
    const { no_signatories_to_open, future_accounts, no_signatories_to_sign } = values;
    const {
      reviewMandateAuthorisedRequiredTerm,
      reviewMandateApplyFutureTerm,
      reviewMandateAuthorisedNumberTerm
    } = externalContent;

    const getMandatesItem = () => {
      let mandatesList = [];
      if (no_signatories_to_open) {
        mandatesList = [
          ...mandatesList,
          {
            key: reviewMandateAuthorisedRequiredTerm,
            value: getLabelByKey(no_signatories_to_open, BUSINESS_MANDATE)
          }
        ];
      }
      if (future_accounts) {
        mandatesList = [
          ...mandatesList,
          {
            key: reviewMandateApplyFutureTerm,
            value: getLabelByKey(future_accounts, BUSINESS_MANDATE_ACCOUTS)
          }
        ];
      }
      if (no_signatories_to_sign && future_accounts === 'Y') {
        mandatesList = [
          ...mandatesList,
          {
            key: reviewMandateAuthorisedNumberTerm,
            value: getLabelByKey(no_signatories_to_sign, BUSINESS_MANDATE)
          }
        ];
      }
      return mandatesList;
    };
    if (!this.state.isEdit) {
      return <GenericDescriptionList items={getMandatesItem()} />;
    }
    return (
      <BusinessMandateGroup
        bankId={bankId}
        getBusinessData={values}
        reviewFlag={true}
        pristine={pristine}
        values={values}
      />
    );
  }

  saveBusinessMandateForm(e) {
    this.props.saveBusinessMandateForm(e);
    this.setState({ isEdit: !this.state.isEdit });
    this.props.editClick(!this.state.isEdit);
    this.props.onValueChanges(true);
  }

  render() {
    const {
      businessMandatedata,
      linkCode,
      externalContent: { changesNotSaved, confirmChanges }
    } = this.props;

    return (
      <div>
        <Form
          onSubmit={this.saveBusinessMandateForm}
          initialValues={businessMandatedata}
          render={({ handleSubmit, values, pristine }) => (
            <form onSubmit={handleSubmit}>
              {this.renderContentType(values, pristine)}
              {this.state.isEdit && (
                <div>
                  <ActionButton.Primary
                    labelText={confirmChanges}
                    onClick={() => this.updateAccordionForm}
                  />
                  <p>{changesNotSaved}</p>
                </div>
              )}
              {!linkCode && (
                <Inline.LeftAligned
                  nodes={[
                    <NavigationButton.Tertiary
                      labelText={this.state.isEdit ? 'Cancel Editing' : 'Edit'}
                      onClick={this.handleEditClick}
                    />
                  ]}
                />
              )}
            </form>
          )}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  externalContent: content(state)
});
export default connect(mapStateToProps, null)(BusinessMandateAccordion);
